export default __webpack_public_path__ + "static/media/landing_teams_sharing.629b8ca9.jpg";